import { useContext } from "react";

import { UserContext } from "../../../model/contexts/user.context";
import { useTasks } from "../../../model/contexts/task.context";
import { NoteContext } from "../../../model/contexts/note.context";

import {
  getPriorityLabel,
  getPriorityClass,
  getStatusClass,
} from "../../../controller/global.function.library";

import "./TaskListFeed.scss";

const TaskListFeed = ({
  currentProject,
  selectedProjectIsEditable,
  filteredTasks,
  setFilteredTasks,
  selectedMenuTag,
  setSelectedTag,
  setArchiveTag,
  undoArchiveTag,
  setTaskData,
  setIsTaskFormModalVisible,
  setIsFormEditMode,
  setIsNoteFormModalVisible,
  capitalizeFirstLetter,
  dateConverted,
}) => {
  const {
    user,
    currentUser,
    authUser: contextAuthUser,
  } = useContext(UserContext);

  const authUser = contextAuthUser || user || currentUser;

  const { setCurrentTask, removeTask } = useTasks();
  const { fetchAllNotesFromTask } = useContext(NoteContext);

  const handleNotesCollectionViewClick = async (task) => {
    const uid = authUser?.uid || null;
    const projectId = currentProject?.id || null;
    const taskId = task?.id || null;

    if (!projectId || !taskId) return;

    localStorage.setItem("selectProjectID", projectId);
    localStorage.setItem("selectTaskID", taskId);
    localStorage.setItem("selectTaskName", task.name || "");

    try {
      await fetchAllNotesFromTask();
      setIsNoteFormModalVisible(true);
    } catch (error) {
      console.error("[VIEW NOTES FETCH ERROR]", {
        uid,
        projectId,
        taskId,
        message: error?.message,
        response: error?.response?.data,
      });
    }
  };

  const handleDeleteClick = async (taskId) => {
    if (!selectedProjectIsEditable) return;

    const uid = authUser?.uid || null;
    const projectId = currentProject?.id || null;

    if (!uid || !projectId || !taskId) {
      console.error("[DELETE BLOCKED]", { uid, projectId, taskId });
      return;
    }

    try {
      const updatedTasks = filteredTasks.filter((task) => task.id !== taskId);
      setFilteredTasks(updatedTasks);

      if (selectedMenuTag === "Archived" && updatedTasks.length === 0) {
        setSelectedTag("All");
      }

      await removeTask({ uid, projectId, taskId });
    } catch (error) {
      console.error("[DELETE ERROR]", {
        uid,
        projectId,
        taskId,
        message: error?.message,
        response: error?.response?.data,
      });
    }
  };

  const handleEditClick = (task) => {
    if (!selectedProjectIsEditable) return;

    setIsTaskFormModalVisible(true);
    setCurrentTask(task);
    setIsFormEditMode(true);
    setTaskData(task);
  };

  return (
    <div className="task-list-container">
      <div className="task-list-feed-container">
        {filteredTasks.map((task) => (
          <div key={task.id} className="task-container">
            <div className="task-info">
              <div className="task-info-text-container">
                <div className="task-name-text-container">
                  <div className="task-name-text">{task.name}</div>

                  {!selectedProjectIsEditable && (
                    <div className="task-view-only-badge">View Only</div>
                  )}
                </div>

                <div
                  className={`task-status-tag ${getStatusClass(task.status)}`}
                >
                  Status: {task.status}
                </div>
              </div>

              <p className="task-description-text">
                Summary: {task.description}
              </p>

              <div className="task-description-info-actions">
                <div className="task-label-container">
                  <p
                    className={`task-priority ${getPriorityClass(
                      task.priority,
                    )}`}
                  >
                    Priority: {getPriorityLabel(task.priority)}
                  </p>

                  {/* {task.tag && task.tag.trim() !== "" && (
                    <p className="task-label">
                      Label: {capitalizeFirstLetter(task.tag)}
                    </p>
                  )} */}
                </div>

                <div className="task-actions">
                  <small className="task-list-metadata-custom-required-text">
                    Last Modified:&nbsp;
                    {dateConverted(task.dateModified)}
                  </small>

                  <button
                    className="action-button view-notes"
                    onClick={() => handleNotesCollectionViewClick(task)}
                  >
                    View Notes
                  </button>

                  {selectedProjectIsEditable ? (
                    <>
                      <span className="action-separator">|</span>

                      <button
                        className="action-button task-edit"
                        onClick={() => handleEditClick(task)}
                      >
                        Edit
                      </button>

                      <span className="action-separator">|</span>

                      {selectedMenuTag !== "Archived" ? (
                        <button
                          className="action-button task-archive"
                          onClick={() =>
                            setArchiveTag(currentProject.id, task, "archived")
                          }
                        >
                          Archive
                        </button>
                      ) : (
                        <>
                          <button
                            className="action-button task-unarchive"
                            onClick={() =>
                              undoArchiveTag(currentProject.id, task, "")
                            }
                          >
                            Unarchive
                          </button>

                          <span className="action-separator">|</span>

                          <button
                            className="action-button task-delete"
                            onClick={() => handleDeleteClick(task.id)}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <span className="action-separator">|</span>
                      <span className="view-only-text">View Only</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskListFeed;
